/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2025 HG Digital/Setera
 * Todos os direitos reservados.
 * 
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 08-01-2025
 * Autor     : System
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

/**
 * Wrapper para importação dinâmica do @superset-ui/embedded-sdk
 * para evitar problemas de transpilação com webpack
 */
export async function loadSupersetSDK() {
  try {
    // Importação dinâmica para evitar problemas de build
    const module = await import('@superset-ui/embedded-sdk');
    return module;
  } catch (error) {
    console.error('Erro ao carregar Superset SDK:', error);
    throw error;
  }
}

